import React, { useState } from "react"
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import IMG4 from "../imgmencoba2/4.png";
const Coba4 = () => {
	const [styleno1, setStyleno1] = useState({ width: "50px" });
	const [styleno2, setStyleno2] = useState({ width: "50px" });
	const [styleno3, setStyleno3] = useState({ width: "50px" });
	const handleNo1 = (no1) => {
		const jwb = no1.target.value;
		jwb === "3"
			? setStyleno1({
					width: "50px",
                    border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno1({
					width: "50px",
                    border: "6px solid yellow",
			  })
			: setStyleno1({
					width: "50px",
                    border: "6px solid red",
			  });
	};
	const handleNo2 = (no2) => {
		const jwb = no2.target.value;
		jwb === "4"
			? setStyleno2({
					width: "50px",
                    border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno2({
					width: "50px",
                    border: "6px solid yellow",
			  })
			: setStyleno2({
					width: "50px",
                    border: "6px solid red",
			  });
	};
    const handleNo3 = (no3) => {
		const jwb = no3.target.value;
		jwb === "12"
			? setStyleno3({
					width: "50px",
                    border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno3({
					width: "50px",
                    border: "6px solid yellow",
			  })
			: setStyleno3({
					width: "50px",
                    border: "6px solid yellow",
			  });
	};
	return (
		<div className="container">
			<div className="d-flex justify-content-center">
				<TransformWrapper defaultScale={1}>
					<TransformComponent>
						<img
							style={{ width: "700px", height: "500px" }}
							src={IMG4}
							alt="gambar4"
						/>
					</TransformComponent>
				</TransformWrapper>
			</div>
            <div className="mt-2" style={{display:'flex', justifyContent:'space-between',width:'30%',margin:'auto'}}>
            <input type="text" onChange={handleNo1}  style={styleno1} /><h4><i>x</i></h4>
            <h2> - </h2>
            <input type="text" onChange={handleNo2}  style={styleno2} /><h4><i>y</i></h4>
			<h2> ≤ </h2>
            <input type="text" onChange={handleNo3}  style={styleno3} />

            </div>
		</div>
	);
};

export default Coba4;
